export const firstOrDefault = (source, predicate) => {
    if (predicate) {
        return firstOrDefault2(source, predicate);
    }
    else {
        return firstOrDefault1(source);
    }
};
const firstOrDefault1 = async (source) => {
    const first = await source[Symbol.asyncIterator]().next();
    return first.value ?? null;
};
const firstOrDefault2 = async (source, predicate) => {
    for await (const value of source) {
        if (predicate(value) === true) {
            return value;
        }
    }
    return null;
};
